<template>
  <div class="d-flex field field--quantity flex-row justify-content-end h-100">
    <label 
      v-if="label" 
      class="mr-3 ml-0 font-weight-light"
    >
      {{ label }}:
    </label>
    
    <button 
      @click="handleClickDecrease" 
      type="button" 
      class="border-right-0 h-100 border"
    >
      -
    </button>
    <input 
      class="text-center border-left-0 border-right-0"
      type="number" 
      maxlength="2" 
      v-model="quantity" 
      :title="label"
      @input="handleInput"
    />
    <button 
      @click="handleClickIncrease" 
      type="button" 
      class="border-left-0 h-100 border"
    >
      +
    </button>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },

    allowZero: {
      type: Boolean,
      default: false
    },

    defaultValue: {
      type: Number
    }
  },

  data() {
    return {
      quantity: 1
    }
  },

  mounted() {
    if (this.defaultValue) {
      this.quantity = this.defaultValue
    }
  },

  methods: {
    handleClickDecrease() {
      if (this.quantity === 1 && !this.allowZero) {
        return
      }

      this.quantity -= 1
      
      this.$nextTick(() => {
        this.$emit('update-quantity', this.quantity)
      })
    },

    handleClickIncrease() {
      this.quantity += 1
      
      this.$nextTick(() => {
        this.$emit('update-quantity', this.quantity)
      })
    },

    handleInput() {
      this.$emit('update-quantity', this.quantity)
    }
  }
}
</script>